import { SvgIcon } from '@/core/ui';
import { shouldNotForwardProps } from '@/shared/helpers';
import { TrackableStatus } from '@/shared/models';
import { styled } from '@mui/material';
export const TrackableIconBox = styled('div')(({ theme }) => ({
    paddingTop: theme.spacing(0.75),
}));
export const TrackableSvgIcon = styled(SvgIcon, shouldNotForwardProps('status'))(({ theme, status }) => ({
    paddingTop: theme.spacing(0.75),
    ...(status === TrackableStatus.Unconfirmed && { filter: 'grayscale(100%);', opacity: 0.5 }),
}));
